import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import nl from './locales/nl.json';

export const SUPPORTED_LOCALES = ['en', 'nl'];
export const DEFAULT_LOCALE = 'en';
export const LOCALE_STORAGE_KEY = 'hireportal_locale';

export const normalizeLocale = (locale) => {
  const value = String(locale ?? '').trim().toLowerCase();
  return SUPPORTED_LOCALES.includes(value) ? value : DEFAULT_LOCALE;
};

export const getStoredLocale = () => {
  try {
    return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch {
    return DEFAULT_LOCALE;
  }
};

export const persistLocale = (locale) => {
  const next = normalizeLocale(locale);
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, next);
  } catch {
    // ignore storage errors
  }
  return next;
};

export const applyLocale = async (locale) => {
  const next = persistLocale(locale);
  if (i18n.language !== next) {
    await i18n.changeLanguage(next);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next;
  }
  return next;
};

const initialLocale = getStoredLocale();

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    lng: initialLocale,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLocale;
}

export default i18n;
